import React from "react";

export function SectionHeading({ overline, title, kicker, align = "center" }) {
  const centered = align === "center";
  return (
    <div className={centered ? "mx-auto max-w-3xl text-center" : "max-w-3xl"}>
      {overline ? (
        <div className={`mb-4 flex items-center gap-3 font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-[#002D72] ${centered ? "justify-center" : ""}`}>
          <span className="h-px w-8 bg-[#28D8FF]" />
          {overline}
          {centered ? <span className="h-px w-8 bg-[#28D8FF]" /> : null}
        </div>
      ) : null}
      <h2 className="font-display text-3xl font-bold leading-[1.1] tracking-tight text-[#0A111F] sm:text-4xl md:text-5xl md:leading-[1.05]">{title}</h2>
      {kicker ? <p className="mt-5 text-base text-slate-600 md:text-lg">{kicker}</p> : null}
    </div>
  );
}
